import { Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import Zoom from '@material-ui/core/Zoom';
import ClearIcon from '@material-ui/icons/Clear';
import React from 'react';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Zoom ref={ref} {...props} />;
});

export default function ImageModal({
  open,
  onClose,
  imageSrc,
}: {
  open: boolean;
  imageSrc?: string;
  onClose(event: any): void;
}): React.ReactElement {
  return (
    <Dialog open={open} onClose={onClose} TransitionComponent={Transition}>
        <IconButton
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 2,
            background: 'rgba(0,0,0,0.6)',
            color: 'white',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            border: '2px solid white',
            padding: 4,
            borderRadius: 20,
            width: 28,
            height: 28,
          }}
          onClick={onClose}>
          <ClearIcon />
        </IconButton>
      <DialogContent style={{ padding: '40px' }}>
        <img src={imageSrc} alt={imageSrc} width="100%" />
      </DialogContent>
    </Dialog>
  );
}
